<template>
    <div class="configOwnerOptionVue">
        <div class="col-md-10 o-config-side-padd c-common-box-shadow u-bg-color-fff" v-loading="saving">
            <div class="owner-option">

                 <div class="col-md-12 o-no-padding">
                    <div class="col-md-6">
                        <h3>Owner Options <span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span></h3>
                    </div>
                    <div class="col-md-6 text-right">
                         <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="goTojobList()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="saveOptions()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Turnover:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <!-- <input type="text" class="form-control" placeholder="Text Input" v-model="client.turnover"> -->
                                            <div class="o-cutsomSelect o-timzone-arrow">
                                            <select v-model="client.turnover">
                                                <option :value="item" v-for="(item,index) in hours" :key="index">{{item}} hours</option>
                                                <option value="24" >24 hours</option>
                                            </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2">An employee with less than this amount of time between shifts will be flagged in yellow on the assignment page.</p></div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Call Time Out:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <div>
                                                <label class="o-label-call-timeout">Day</label>
                                                <select v-model="timeout.days" class="o-select-call-timeout">
                                                    <option v-for="(item,index) in days" :value="item" :key="index">{{(item<10)?'0'+item :item}}</option>
                                                </select>
                                                <label class="o-label-call-timeout">Hours</label>
                                                <select v-model="timeout.hours" class="o-select-call-timeout">
                                                    <option v-for="(item,index) in hours" :value="item" :key="index">{{(item<10)?'0'+item :item}}</option>
                                                </select>
                                                <label class="o-label-call-timeout">Minutes</label>
                                                <select v-model="timeout.minutes" class="o-select-call-timeout">
                                                    <option v-for="(item,index) in minutes" :value="item" :key="index">{{(item<10)?'0'+item :item}}</option>
                                                </select>
                                            </div>
                                            <label class="o-instruction-call-timeout">Note:- Default value 00:00:00 means the timer is off.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2">If the time between Notification and the addition of this value are exceeded, Calls will be AUTOMATICALLY CLEARED and marked with a TIMEDOUT.</p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Enable Internet Confirm:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o5" value="1" v-model="client.internet_confirm">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o5" value="0" v-model="client.internet_confirm">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">If enabled, users may confirm and deny their own calls via the web application schedule page.</p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Enable Pass Option:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="pass5" value="1" v-model="client.pass_option">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="pass5" value="0" v-model="client.pass_option">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">If disabled, the Pass option will be removed from the web application schedule and phone pages.</p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Default Status for Assign Page:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                All Lists
                                                <input type="radio" name="default-status" value="all" v-model="client.assign_page_default_status">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Highest Priority Status
                                                <input type="radio" name="default-status" value="priority" v-model="client.assign_page_default_status">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">Load assign page based on the selected default status.</p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Default Sort for Assign Page:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="o-cutsomSelect">
                                            <select v-model="client.default_sort">
                                                <option value="">SELECT</option>
                                                <option value="fname_asc">FirstLast (Employee name)</option>
                                                <option value="lname_asc">LastFirst (Employee name)</option>

                                                <option value="wishlist_asc">Wishlist Timestamp(Ascending)</option>
                                                <option value="wishlist_desc">Wishlist Timestamp (Decending)</option>

                                                <option value="participation_asc">Participation(Ascending)</option>
                                                <option value="participation_desc">Participation(Decending)</option>

                                                <option value="participation_july_june_asc">Participation July June (Ascending)</option>
                                                <option value="participation_july_june_desc">Participation July June (Decending)</option>

                                                <option value="emp_seniority">Employee Seniority (Ascending)</option>
                                                <option value="emp_seniority_desc">Employee Seniority (Decending)</option>

                                                <option value="skill_seniority">Skill Seniority (Ascending)</option>
                                                <option value="skill_seniority_desc">Skill Seniority (Decending)</option>

                                                <option value="location_asc">Location (Ascending)</option>
                                                <option value="location_desc">Location (Decending)</option>

                                                <option value="shift_total_asc">Total Shift (Ascending)</option>
                                                <option value="shift_total_desc">Total Shift (Decending)</option>

                                                <option value="shift_weekly_asc">Weekly Shift (Ascending)</option>
                                                <option value="shift_weekly_desc">Weekly Shift (Decending)</option>

                                                <option value="shift_july_june_asc">Shift July June (Ascending)</option>
                                                <option value="shift_july_june_desc">Shift July June (Decending)</option>

                                                <option value="shift_YTD_asc">Shift YTD (Ascending)</option>
                                                <option value="shift_YTD_desc">Shift YTD (Decending)</option>

                                                <option value="decline_total__asc">Decline Total (Ascending)</option>
                                                <option value="decline_total__desc">Decline Total (Decending)</option>

                                                <option value="decline_weekly_asc">Decline Weekly (Ascending)</option>
                                                <option value="decline_weekly_desc">Decline Weekly (Decending)</option>

                                                <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                                <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                                <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                                <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                                <option value="last_offer_asc">Last Offer  (Ascending)</option>
                                                <option value="last_offer_desc">Last Offer (Decending)</option>

                                                <option value="last_assigned_asc">Last Assigned  (Ascending)</option>
                                                <option value="last_assigned_desc">Last Assigned (Decending)</option>

                                                <option value="last_confirmed_asc">Last Confirmed  (Ascending)</option>
                                                <option value="last_confirmed_desc">Last Confirmed (Decending)</option>

                                                <option value="wishlist_seniority">Wishlist by Seniority</option>

                                                <!-- <option value="emp_seniority">Employee Seniority</option>
                                                <option value="skill_seniority">Skill Seniority</option>
                                                <option value="fname_asc">FirstLast (Employee name)</option>
                                                <option value="fname_desc">LastFirst (Employee name)</option>
                                                <option value="participation_asc">Participation(Ascending)</option>
                                                <option value="participation_desc">Participation(Decending)</option>
                                                <option value="wishlist_asc">Wishlist Timestamp(Ascending)</option>
                                                <option value="wishlist_desc">Wishlist Timestamp (Decending)</option> -->
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Default Sort for Call List:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="o-cutsomSelect">
                                            <select v-model="client.default_call_sort">
                                                <option value="">SELECT</option>
                                                <option value="start">Start time</option>
                                                <option value="skill">Skill</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Default Sort for Phone Sheet:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="o-cutsomSelect">
                                            <select v-model="client.default_phonesheet_sort">
                                                <option value="">SELECT</option>
                                                <option value="fname_asc">FirstLast (Employee name)</option>
                                                <option value="lname_asc">LastFirst (Employee name)</option>
                                                <option value="seniority">Seniority</option>
                                                <option value="skill">Skill</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Default Sort for Employee List:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="o-cutsomSelect">
                                            <select v-model="client.default_employee_sort">
                                                <option value="">SELECT</option>
                                                <option value="fname_asc">FirstLast (Employee name)</option>
                                                <option value="fname_desc">LastFirst (Employee name)</option>
                                                <option value="seniority">Seniority </option>
                                                <option value="email">Email ID</option>
                                                <option value="member_since">Member Since</option>
                                                <option value="date_of_hire">Date of Hire</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-8">
                                <p class="ps2">An employee with less than this amount of time between shifts will be flagged in yellow on the assignment page.</p>
                            </div> -->
                        </div>
                    </div>
                    <!-- <div class=" border-bottom-only u-padding-30">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Reports:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o3" value="">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o3" value="" checked="">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2">If your organization does not   require job reports and H/W reports for each job, select 'no' to disable them.</p></div>
                        </div>
                    </div> -->

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Time Zone:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="o-cutsomSelect o-timzone-arrow">
                                            <!-- <select v-model="client.timezone">
                                                <option value="" >SELECT</option>
                                                <option :value="timezone" v-for="timezone in timezones">{{timezone}}</option>
                                            </select> -->
                                            <el-select v-model="client.timezone" filterable placeholder="Select" style="width:100%">
                                                <el-option
                                                  v-for="item in list"
                                                  :key="item.value"
                                                  :label="item.value"
                                                  :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <!-- <el-select
                                              v-model="client.timezone"

                                              filterable
                                              remote
                                              reserve-keyword
                                              placeholder="Please enter a keyword"
                                              :remote-method="remoteMethod"
                                              :loading="loading">
                                              <el-option
                                                v-for="item in options4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                              </el-option>
                                            </el-select> -->

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2">Conflicts are highlighted in Yellow when the time between shifts are les than this value.<!-- An employee with less than this amount of time between shifts will be flagged in yellow on the assignment page. --></p></div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Logo:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="form-group-right">
                                            <div class="logo-upload-sec">
                                                <div class="logo-upload config-logo-img-border">
                                                    <img :src="(logo_image == '')?'static/assets/images/user4.png':logo_image" alt="" id="img-upload">
                                                </div>
                                                <div class="logo-upload-btn">
                                                    <div class="input-group">
                                                        <span class="input-group-btn">
                                                            <span class="btn btn-default btn-file"><input type="file" id="imgInp" @change="uploadImage($event,'logo')">
                                                            </span>
                                                        </span>
                                                        <input type="text" class="form-control" readonly="">
                                                    </div>
                                                    <i class="fa fa-plus"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Login image:</label>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="form-group-right">
                                            <div class="login-upload-sec">
                                                <div class="login-upload config-logo-img-border">
                                                    <img :src="(login_image == '')?'static/assets/images/user4.png':login_image" alt="" id="img-upload">
                                                </div>
                                                <div class="login-upload-btn">
                                                    <div class="input-group">
                                                        <span class="input-group-btn">
                                                            <span class="btn btn-default btn-file"><input type="file" id="imgInp" @change="uploadImage($event,'login')">
                                                            </span>
                                                        </span>
                                                        <input type="text" class="form-control" readonly="">
                                                    </div>
                                                    <i class="fa fa-plus"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <p class="logo-image-note">
                                    Please upload logo images in <strong>PNG</strong> with <strong>same height and width</strong>, minimum height 100px for better appearance.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Login Page Greeting:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <textarea class="form-control" rows="10" placeholder="Type your message" v-model="client.login_page_message"  name="editor1" id="editor1"></textarea>
                                            <!-- <vue-editor class="c-common-box-shadow c-radius3"  v-model="client.login_page_message"></vue-editor> -->
                                            <!-- <ckeditor type="classic" v-model="client.login_page_message" :config="editorConfig"></ckeditor> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Power Users allowed to edit Splash Page:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <el-select
                                                v-model="selectedEditors"
                                                multiple
                                                filterable
                                                placeholder="Select power users..."
                                                style="width: 100%;"
                                                @change="saveEditors"
                                            >
                                                <el-option
                                                    v-for="pu in powerUsers"
                                                    :key="pu.id"
                                                    :label="pu.first_name + ' ' + pu.last_name"
                                                    :value="pu.id"
                                                ></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>CS Privacy Policy:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <router-link to="/privacy-policy-editor" class="c-solid-btn c-solid-btn--green" style="display: inline-block;">
                                                <i class="fa fa-shield" aria-hidden="true"></i> Edit Privacy Policies
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label class="cust-sms-label">Auto response for confirmed delete or clear:</label>
                                            <label class="cust-sms-length">{{getLength(client.custom_call_clear_mssg)}}/100</label>
                                            <label class="predefined-message">Your call on [Call Date] has been canceled.</label>
                                        </div>
                                        <div class="form-group-right">
                                            <textarea v-model="client.custom_call_clear_mssg" class="form-control" maxlength="100" rows="4" placeholder="Type your message" name="sms-text-1"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-6">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label class="cust-sms-label">Auto response for confirmed edit:</label>
                                            <label class="cust-sms-length">{{getLength(client.custom_call_edit_mssg)}}/100</label>
                                        </div>
                                        <div class="form-group-right">
                                            <textarea v-model="client.custom_call_edit_mssg" class="form-control" maxlength="100" rows="4" placeholder="Type your message" name="sms-text-2"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Custom fields 1:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <input type="text" class="form-control" placeholder="Text Input" v-model="custom_field1">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Custom fields 2:</label>
                                        </div>
                                        <div class="form-group-right">
                                            <input type="text" class="form-control" placeholder="Text Input" v-model="custom_field2">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Show on which pages:</label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Employee List
                                                <input type="checkbox" name="o4" value="1"  v-model="client.employee_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Call Assignment
                                                <input type="checkbox" name="o4" value="1" v-model="client.call_assignment_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                Phone Sheet
                                                <input type="checkbox" name="o4" value="1" v-model="client.call_sheet_title">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Hide Empty Days:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="o3" value="1" v-model="client.hide_empty_days">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="o3" value="0" v-model="client.hide_empty_days">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    On the calendar, if no calls are scheduled between the start date and end date, the displayed bar will not span those days.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Select to lock or unlock skillset:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Locked
                                                <input type="radio" name="o10" :value="true" v-model="skill_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Unlocked
                                                <input type="radio" name="o10" :value="false" v-model="skill_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <!-- <div class="o-pub">
                                            <div class="o-accordion-element">
                                                <div class="toggle-btn">
                                                  <el-switch
                                                    style="display: block"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"

                                                    v-model="skill_lock"

                                                  >
                                                  </el-switch>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    This is a global lock that will capture all user profiles and lock or unlock skill sets, allowing users to update their own skill profiles.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Wished Access:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="Wishlist" value="1" v-model="client.wishlist_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="Wishlist" value="0" v-model="client.wishlist_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, user can wished jobs from user schedule and calendar.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Ignored Access:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Yes
                                                <input type="radio" name="Ignoredlist" value="1" v-model="client.ignorelist_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                No
                                                <input type="radio" name="Ignoredlist" value="0" v-model="client.ignorelist_lock">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, user can ignored jobs from user schedule and calendar.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Power Steward:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Enabled
                                                <input type="radio" name="PowerSteward" :value="1" v-model="client.power_steward">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Disabled
                                                <input type="radio" name="PowerSteward" :value="0" v-model="client.power_steward">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, This should allow job stewards to take all action, within the context of the job they create.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Show Global Skills:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.global_skills"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, This should allow Global Skills visible in the Add-Job/Edit-Job they create.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Notify Templates:</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-7">
                                            <div class="box-setup-notify-templates">
                                                <span class="template-items" v-for="(template,index) in templateMsgs" :key="index">
                                                    <span class="ps-message-suggestions">
                                                        {{ template }}
                                                        <span @click="deleteTemplate(index)">
                                                            <i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i>
                                                        </span>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="box-setup-notify-templates">
                                                <div class="o-no-padding">
                                                    <h2 class="h2">Add Template:</h2>
                                                </div>
                                                <div class="o-no-padding">
                                                    <div class="form-group">
                                                        <label class="template-label">Template Name:</label>
                                                        <label class="employee-label-input w-75">
                                                            <input type="text" class="form-control" name="templateName" placeholder="Template" v-model="templateName">
                                                            <span v-show="errors.has('templateName') && this.validation_err!=0" class="err-msg">{{ errors.first('templateName') }}</span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div class="o-no-padding">
                                                    <div class="o-employe-view">
                                                        <a href="javascript: void(0)" @click="addTemplate()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i>{{ $t('save') }}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                     <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Billing Contact:</label>
                                        </div>
                                        <!-- <div class="clearfix"></div> -->
                                        <!-- <div class="o-cutsomSelect"> -->

                                        <el-select allow-create v-model="billing_contact" @change="selectEmail()" style="width:100%;" filterable placeholder="Select Steward">
                                            <el-option
                                                v-for="(steward,index) in stewardsList"
                                                :key="index"
                                                :label="steward.last_name+', '+steward.first_name"
                                                v-validate="'required'"
                                                :value="steward.id">
                                            </el-option>
                                        </el-select>
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Billing email:</label>
                                        </div>
                                        <!-- <div class="clearfix"></div> -->
                                        <!-- <div class="o-cutsomSelect"> -->
                                            <input type="text" class="form-control" placeholder="Text Input" v-model="billing_email">
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>  </label>
                                        </div>
                                        <ul class="o-filter-area">
                                            <li>
                                                <a href="javascript: void(0)" @click="changeBillingContact()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Show Batch Notify:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.batch_notify_flag"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, This should allow Batch Notify visible in the Phone-Sheet.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Show Rate:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.display_rate"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, This should allow Rate visible in the Employee-Schedule.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Suppress Hippa Collection:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.supress_hippa_collection"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, this should suppress the employee medical condition, and regular medications with default text in the Employee Profile.
                                </p>
                            </div>
                        </div>
                    </div>
                     <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Suppress Steward Report:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.suppress_steward_report"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, the Steward Report button will be hidden on the Job Details page.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Suppress SMS Notifications:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.suppress_sms"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, SMS phone sheet notifications will be disabled for all employees. Employee SMS toggles will be greyed out.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Hide Drive from Basic User:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.hide_drive_basic_user"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    If enabled, Drive will be hidden from basic users unless they have documents shared directly to them.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Public Calendar:</label>
                                        </div>
                                        <el-switch
                                        style="display: block"
                                        v-model="client.public_calendar_enabled"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    Enable a public Google Calendar that shows published jobs. Embed the calendar on your website.
                                </p>
                                <p class="ps2" style="color:#888; margin-top:4px;">
                                    To add a description to a calendar event, create a job note prefixed with <strong>pubcal://</strong> (e.g. <em>pubcal://Doors open at 7pm</em>). The text after the prefix will appear in the event details.
                                </p>
                                <div v-if="client.public_calendar_enabled && client.google_calendar_embed_url" class="o-margin-top5">
                                    <label>Embed URL:</label>
                                    <input type="text" class="form-control" :value="client.google_calendar_embed_url" readonly @click="$event.target.select()" />
                                    <p class="ps2 o-margin-top5">
                                        <small>Copy this URL into an iframe on your website:<br/>
                                        <code>&lt;iframe src="{{ client.google_calendar_embed_url }}" width="800" height="600" frameborder="0"&gt;&lt;/iframe&gt;</code></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="form-group-left">
                                        <label>Employee Notifications:</label>
                                    </div>
                                    <div class="clearfix">
                                        {{$t('app') }}:
                                        <el-switch
                                        v-model="notifyApp"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value = 1
                                        :inactive-value = 0
                                        @change="changeClientNotifyPreference('app')"
                                        class="mr-30"
                                        >
                                        </el-switch>
                                        {{$t('email_primary') }}:
                                        <el-switch
                                        v-model="notifyEmail"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value = 1
                                        :inactive-value = 0
                                        @change="changeClientNotifyPreference('email')"
                                        class="mr-30"
                                        >
                                        </el-switch>
                                        {{$t('sms_cell') }}:
                                        <el-switch
                                        v-model="notifySms"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value = 1
                                        :inactive-value = 0
                                        :disabled="!!client.suppress_sms"
                                        @change="changeClientNotifyPreference('sms')"
                                        class="mr-30"
                                        >
                                        </el-switch>
                                        <span v-if="client.suppress_sms" style="color: #999; font-size: 11px;">(suppressed)</span>

                                        <!-- {{$t('stop') }}
                                        <el-switch
                                        v-model="notifyStop"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value = 1
                                        :inactive-value = 0
                                        @change="changeClientNotifyPreference('stop')"
                                        >
                                        </el-switch> -->

                                        <!-- <el-switch
                                        style="display: block"
                                        v-model="client.global_skills"
                                        active-color="#13ce66"
                                        inactive-color="#dcdfe6"
                                        :active-value=1
                                        :inactive-value=0
                                        @change="saveOptions"
                                        >
                                        </el-switch> -->
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <p class="ps2 o-margin-top5">
                                    Selected notification channels will be forced on all employees.
                                    <br />
                                    This may need to be done on occasion to reset user preferences to your default.
                                </p>
                            </div>
                        </div>
                    </div>


                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Public Calendar:</label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                On
                                                <input type="radio" name="pubcal" :value="true" v-model="publicCalendarEnabled">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                        <div class="radio o-custom-radio">
                                            <label>
                                                Off
                                                <input type="radio" name="pubcal" :value="false" v-model="publicCalendarEnabled">
                                                <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <p class="ps2 o-margin-top5">
                                    Enable a public Google Calendar for this client. Published jobs will appear as events. Use the embed code below to display the calendar on an external website.
                                </p>
                                <div v-if="client.public_calendar_enabled && client.google_calendar_embed_url" style="margin-top: 10px;">
                                    <label>Embed Code:</label>
                                    <div style="display: flex; gap: 8px;">
                                        <textarea
                                            readonly
                                            rows="3"
                                            class="form-control"
                                            style="font-family: monospace; font-size: 12px;"
                                            :value="embedSnippet"
                                            ref="embedCode"
                                        ></textarea>
                                        <button type="button" class="btn btn-sm btn-default" @click="copyEmbed" style="white-space: nowrap;">
                                            <i class="fa fa-copy"></i> Copy
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-bottom-only u-padding-15">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group o-no-margin-bottom">
                                    <div class="clearfix">
                                        <div class="form-group-left">
                                            <label>Notify Templates:</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-7">
                                            <input-tag v-model="templateMsgs" :limit="10" @input="saveTags()" :add-tag-on-blur="true" placeholder="Enter your tag and press enter"></input-tag>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import {global} from '../../global.js';
    import service from '../../services.js';
    import InputTag from 'vue-input-tag'
    // #1686 — role-based capability check (the shared 'getPower' source used across the app)
    import dateTimeConvert from '../../timeConvert&Compare';

    import {VueEditor, Quill } from 'vue2-editor';
    // import { ImageDrop } from 'quill-image-drop-module'
    // import ImageResize from 'quill-image-resize-module'

    // Quill.register('modules/imageDrop', ImageDrop)
    // Quill.register('modules/imageResize', ImageResize)

    export default {
        components: {
            VueEditor,
            InputTag
        },
        data() {
            return {
                notifyApp: 0,
                notifyEmail: 0,
                notifySms: 0,
                notifyStop: 0,
                templateName: "",
                client: {},
                saving: false,
                publicCalendarEnabled: false,
                logo_image: "",
                login_image: "",
                custom_field1: "",
                custom_field2: "",
                skill_lock: false,
                timezones : moment.tz.names(),
                options4: [],
                value9: [],
                list: [],
                loading: false,

                days:[0,1,2,3,4,5],
                hours:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                minutes:[0,5,10,15,20,25,30,35,40,45,50,55],
                timeout:{
                    days:0,
                    hours:0,
                    minutes:0
                },
                editorConfig:{
                    // removePlugins: [ 'imageUpload'],
                    toolbar: [ 'Heading', '|', 'bold', 'italic', 'Link', '|', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo']
                },
                templateMsgs: [],
                tempTemplates: [],
                tags: [
                    'Please login to Confirm',
                    'TIME CHANGE Please Login',
                    'SHORT NOTICE',
                    'Call Dispatch ASAP',
                    'Work Available',
                    'Please RE-CONFIRM ASAP',
                    'Please login to ConfirmPass or Decline',
                    'Respond within',
                    'This Offer expires within',
                    'Please Confirm or Decline'
                ],
                stewardsList: [],
                billing_contact: '',
                billing_email: '',
                powerUsers: [],
                selectedEditors: []
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
            }),
            embedSnippet() {
                if (!this.client.google_calendar_embed_url) return '';
                return '<iframe src="' + this.client.google_calendar_embed_url + '" style="border: 0" width="800" height="600" frameborder="0" scrolling="no"></iframe>';
            },
        },
        methods: {
            copyEmbed() {
                if (this.$refs.embedCode) {
                    this.$refs.embedCode.select();
                    document.execCommand('copy');
                    this.$notify({
                        title: 'Copied',
                        message: 'Embed code copied to clipboard.',
                        type: 'success'
                    });
                }
            },
            // #1686 — shared role capability check (same delegate the rest of the app
            // uses for getPower('config')): CA/SA → true; power-user/-minus/auditor/
            // employee → false for 'config'.
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            getLength(text){
                if(text)
                    return text.length;
                return 0;
            },
            handleImageAdded(file, Editor, cursorLocation, resetUploader) {
                var formData = new FormData();
                formData.append('image', file);
                // console.log(formData);
            },
            getCallTimeout(){
                var hours = (this.timeout.days*24)+this.timeout.hours;
                var minutes =this.timeout.minutes;
                return Math.round(hours)+':'+Math.round(minutes);
            },

            setCallTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];
                this.timeout.days=Math.round(hours/24);
                this.timeout.hours=Math.round(hours%24);
                this.timeout.minutes=Math.round(minutes);
            },

            goTojobList() {
                this.$router.push({
                    'path': "/jobList"
                });
            },

            saveOptions() {
                // #1686 — Owner Options editing is Client-Admin / Super-Admin only (the
                // 'config' power). This page also auto-saves on many @change events, so
                // gate the SAVE method itself (covers the Save button AND every @change).
                // The backend ownerOptions endpoint enforces the same gate (403); this is
                // the matching frontend guard so a non-CA who URL-navigates here can view
                // but not write.
                if (!this.getPower('config')) {
                    this.$notify({
                        title: 'Access denied',
                        message: 'Only a Client Admin can edit Owner Options.',
                        type: 'error'
                    });
                    return;
                }
                // Guard against saving before getClientData() has populated this.client.
                // Without a client id the backend rejects with 400 "client_id is required".
                if (!this.client || !this.client.id) {
                    return;
                }
                this.saving = true;
                this.client.employee_title = (this.client.employee_title == true) ? 1 : 0;
                this.client.call_sheet_title = (this.client.call_sheet_title == true) ? 1 : 0;
                this.client.call_assignment_title = (this.client.call_assignment_title == true) ? 1 : 0;
                this.client.phonesheet_ts=this.getCallTimeout();

                // Build a lean payload with only the fields the backend needs
                var payload = {
                    client_id: this.client.id,
                    internet_confirm: this.client.internet_confirm,
                    pass_option: this.client.pass_option,
                    reports: this.client.reports,
                    timezone: this.client.timezone,
                    logo: this.client.logo,
                    login_image: this.client.login_image,
                    default_sort: this.client.default_sort,
                    default_employee_sort: this.client.default_employee_sort,
                    default_call_sort: this.client.default_call_sort,
                    default_phonesheet_sort: this.client.default_phonesheet_sort,
                    // #1685 — read the greeting from CKEditor whenever the editor
                    // exists. The old `this.client.client_employees &&` guard tied a
                    // greeting save to the employee pivot, which Owner Options does
                    // NOT eager-load (undefined → falsy), so the edited CKEditor
                    // content was dropped and the STALE v-model value was saved —
                    // the greeting silently reverted (FS #16334, Local 900).
                    login_page_message: CKEDITOR.instances.editor1 ? CKEDITOR.instances.editor1.getData() : this.client.login_page_message,
                    hide_empty_days: this.client.hide_empty_days,
                    employee_title: this.client.employee_title,
                    call_assignment_title: this.client.call_assignment_title,
                    call_sheet_title: this.client.call_sheet_title,
                    phonesheet_ts: this.client.phonesheet_ts,
                    custom_call_clear_mssg: this.client.custom_call_clear_mssg,
                    custom_call_edit_mssg: this.client.custom_call_edit_mssg,
                    turnover: this.client.turnover,
                    power_steward: this.client.power_steward,
                    global_skills: this.client.global_skills,
                    supress_hippa_collection: this.client.supress_hippa_collection,
                    batch_notify_flag: this.client.batch_notify_flag,
                    suppress_steward_report: this.client.suppress_steward_report,
                    suppress_sms: this.client.suppress_sms,
                    hide_drive_basic_user: this.client.hide_drive_basic_user,
                    skill_lock: this.skill_lock,
                    wishlist_lock: this.client.wishlist_lock,
                    ignorelist_lock: this.client.ignorelist_lock,
                    assign_page_default_status: this.client.assign_page_default_status,
                    display_rate: this.client.display_rate,
                    public_calendar_enabled: this.client.public_calendar_enabled,
                };

                var customValue = "";
                if (this.custom_field1 != this.client.custom_field_1)
                    payload.custom_field1 = JSON.stringify({
                        name: this.custom_field1,
                        value: customValue
                    });

                if (this.custom_field2 != this.client.custom_field_2)
                    payload.custom_field2 = JSON.stringify({
                        name: this.custom_field2,
                        value: customValue
                    });

                service.post('employee/ownerOptions', payload, {
                    'Authorization': this.userToken
                })
                .then(async(res) => {
                    this.saving = false;
                    this.$cookies.set("time_zone", this.client.timezone);
                    this.$notify({
                        title: 'Success',
                        message: 'Owner option saved Successfully.',
                        type: 'success'
                    });
                    // Update local client data from the response instead of refetching
                    if (res.data && res.data.result) {
                        Object.assign(this.client, res.data.result);
                    }
                }).catch((err) => {
                    this.saving = false;
                    console.log(err);
                });
            },

            uploadImage(e, type) {
                //console.log(e);
                var input = e.target;
                var img;
                var name;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            name = input.files[0].name;
                            if (type == 'logo')
                                this.logo_image = img;
                            else
                                this.login_image = img;
                            //console.log("login"+this.login_image);
                            service.post('attachment/uploadSingleFile', {
                                    'image_file': img,
                                    'file_name': name

                                }, {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID
                                })
                                .then((res) => {
                                    if (type == 'logo')
                                        this.client.logo = res.data.result.path;
                                    else
                                        this.client.login_image = res.data.result.path;

                                }).catch((err) => {
                                    this.$notify.error({
                                        title: 'Error',
                                        message: 'Image size is too big!'
                                    });
                                });


                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Document size should be less than 500 kb'
                        });
                    }

                }
            },

            remoteMethod(query) {
              if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                  this.loading = false;
                  this.options4 = this.list.filter(item => {
                    return item.label.toLowerCase()
                      .indexOf(query.toLowerCase()) > -1;
                  });
                }, 200);
              } else {
                this.options4 = [];
              }
            },
            deleteTemplate(index){
                // console.log(index);
                this.saveTags();
                delete this.templateList[index];
            },
            saveTags(){
                // console.log(JSON.stringify(this.templateMsgs))
                if(this.templateMsgs.length <= 10) {

                    // {'templates': JSON.stringify(this.tags)}
                    let templates =  JSON.stringify(this.templateMsgs)
                    // console.log(typeof templates);
                    // console.log(typeof JSON.stringify(this.templateMsgs))
                    // console.log(JSON.stringify(this.templateMsgs))
                    service.post('client/updateNotifyTemplate', { templates: templates }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                        'Content-Type': 'application/json'
                    }).then((client) => {
                        // this.getSettings();
                        this.$message.success({
                            message: 'Templates updated successfully'
                        })
                    }).catch((err) => {
                        console.log(err);
                        this.$message.error({
                            message: 'Something went wrong'
                        })
                    });
                }else {
                    this.$notify({
                        type: 'error',
                        title: "Max Limit reached",
                        message: "Maximum Limit of templates is 10"
                    })
                }

            },
            async getClientData() {
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                })
                .then((res) => {
                    this.client = res.data.result;
                    if(!this.client.supress_hippa_collection) {
                        this.client.supress_hippa_collection = 0;
                    }
                    if(!this.client.suppress_steward_report) {
                        this.client.suppress_steward_report = 0;
                    }
                    if(!this.client.suppress_sms) {
                        this.client.suppress_sms = 0;
                    }
                    if(!this.client.hide_drive_basic_user) {
                        this.client.hide_drive_basic_user = 0;
                    }
                    this.getStewardsList();
                    if (this.client.logo != "") {
                        this.logo_image = this.client.logo;
                    }
                    if (this.client.login_image != "") {
                        this.login_image = this.client.login_image;
                    }
                    this.skill_lock = (this.client.skill_lock == 1) ? true : false;
                    this.publicCalendarEnabled = !!this.client.public_calendar_enabled;
                    this.custom_field1 = this.client.custom_field_1;
                    this.custom_field2 = this.client.custom_field_2;
                    this.setCallTimeout(this.client.phonesheet_ts);
                    if(this.client.notify_templates){
                        this.templateMsgs = JSON.parse(this.client.notify_templates)
                        // this.templateMsgs = JSON.parse(tempMsgs.templates)
                    }else {
                        this.templateMsgs = this.tags
                    }
                    this.tempTemplates = this.templateMsgs
                    this.billing_contact=this.client.billing_contact;
                    this.billing_email=this.client.billing_email;
                    // Read notification switches from client settings
                    if (this.client.settings && this.client.settings['notification-switches']) {
                        var switches = this.client.settings['notification-switches'];
                        this.notifyApp = switches.app_notification != null ? switches.app_notification : 1;
                        this.notifySms = switches.sms_notification != null ? switches.sms_notification : 1;
                        this.notifyEmail = switches.email_notification != null ? switches.email_notification : 1;
                        this.notifyStop = switches.stop_notification != null ? switches.stop_notification : 0;
                    } else {
                        // Default to enabled if no settings available
                        this.notifyApp = 1;
                        this.notifySms = 1;
                        this.notifyEmail = 1;
                        this.notifyStop = 0;
                    }
                    // Load saved splash editors
                    if (this.client.settings && this.client.settings['splash-editors']) {
                        this.selectedEditors = this.client.settings['splash-editors'];
                    }
                    // Sync CKEditor with loaded data
                    this.syncEditorContent();
                }).catch((err) => {
                    console.log(err);
                });
            },
            syncEditorContent() {
                var self = this;
                var editor = CKEDITOR.instances.editor1;
                if (editor && editor.status === 'ready') {
                    editor.setData(self.client.login_page_message || '');
                }
                // If editor not ready yet, instanceReady handler will pick it up
            },
            async loadPowerUsers() {
                try {
                    var res = await service.get('employee/getPowerUsers', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    });
                    this.powerUsers = res.data.result || [];
                } catch (err) {
                    console.log('loadPowerUsers error:', err);
                }
            },
            async saveEditors() {
                try {
                    await service.post('client/' + this.userClientID + '/saveClientSettings', {
                        key: 'splash-editors',
                        value: this.selectedEditors
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-clientId': this.userClientID,
                        'cs3-context-role': this.userRole
                    });
                    this.$notify.success({
                        title: 'Success',
                        message: 'Splash page editor access updated'
                    });
                } catch (err) {
                    console.log('saveEditors error:', err);
                    this.$notify.error({
                        title: 'Error',
                        message: 'Failed to update editor access'
                    });
                }
            },
            getStewardsList() {
                console.log("check stewards")
                service.get('employee/getStewards', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((stewards) => {
                        console.log(stewards);
                        this.stewardsList = stewards.data.result;
                        //console.log(this.stewards);
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            selectEmail() {
                console.log(this.billing_contact)
                let index = this.stewardsList.findIndex((steward) => steward.id == this.billing_contact)
                console.log(index);
                console.log("Hello check steward selection");
                if(index>=0) {
                    this.billing_contact = this.stewardsList[index].first_name + ' ' + this.stewardsList[index].last_name;
                    this.billing_email = this.stewardsList[index].email;
                }else{
                    this.billing_email = '';
                }
            },
            changeBillingContact() {
                let params = {
                    client_id: this.userClientID,
                    billing_contact: this.billing_contact,
                    billing_email: this.billing_email,
                };
                service.post('client/updateBillingContacts', params, {
                        'Authorization': this.userToken
                    })
                    .then((res) => {
                        this.$notify.success({
                            title: 'Success',
                            message: 'Billing Contact Updated'
                        })
                        this.getClientData();
                    }).catch((err) => {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Something went wrong'
                        });
                        this.getClientData();
                        console.log(err);
                    });
            },
            changeClientNotifyPreference(type) {
                if(this.notifyApp == 0 && this.notifyEmail == 0 && this.notifySms == 0){
                    this.$notify.error({
                        message: 'Notification must have at least one active channel',
                        title: this.$t('warning')
                    })
                    if(type=='app')
                        this.notifyApp = 1;
                    else if(type=='email')
                        this.notifyEmail = 1;
                    else if(type=='sms')
                        this.notifySms = 1;

                    return;
                } else {
                    var formData = {
                        sms_notification: this.notifySms,
                        email_notification: this.notifyEmail,
                        app_notification: this.notifyApp,
                        stop_notification: this.notifyStop
                    };
                    service.post(`client/${this.userClientID}/resetNotificationSwitch`, formData, {
                        'Authorization': this.userToken,
                        'ClientId': this.userClientID
                    }).then((res) => {
                        this.$notify.success({
                            message: 'Notification channel updated',
                            title: this.$t('success')
                        })
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
                }
            },
        },
        mounted() {
            this.list = this.timezones.map(item => {
                return { value: item, label: item };
            });

            var self = this;
            setTimeout(()=>{
                CKEDITOR.replace( 'editor1', {
                    linkDefaultProtocol: 'https://',
                    linkShowTargetTab: true,
                    contentsCss: [CKEDITOR.basePath + 'contents.css', 'body { color: #ffffff; background: #335479; } a { color: #f1c40f !important; }'],
                    on: {
                        instanceReady: function(evt) {
                            // Load saved content into editor
                            if (self.client && self.client.login_page_message) {
                                evt.editor.setData(self.client.login_page_message);
                            }
                            // Default all new links to open in new window
                            evt.editor.on('dialogShow', function(e) {
                                var dialog = e.data;
                                if (dialog.getName() === 'link') {
                                    var targetTab = dialog.getContentElement('target', 'linkTargetType');
                                    if (targetTab && !dialog.getValueOf('target', 'linkTargetType')) {
                                        dialog.setValueOf('target', 'linkTargetType', '_blank');
                                    }
                                }
                            });
                        }
                    }
                });
            }, 2000);

        },
        async created() {
            await this.getClientData();
            await this.loadPowerUsers();
        }
    }

</script>
<style scoped>
.predefined-message{
    color: #222222;
    font-size: 14px;
    padding-top: 10px;
    padding-left: 15px;
}
.logo-image-note{
    padding: 5%;
    font-size: 14px;
    color: #222222;
    line-height: 2;
}
.cust-sms-label{
    width:80% !important;
}
.cust-sms-length{
    width:19% !important;
    text-align: right;
}
.box-setup-notify-templates{
    margin-top: 10px;
    padding: 15px !important;
    border: solid 1px #B8CBDC !important;
}
.template-items {
    /* background-color: #55A2A2; */
    /* color: #ffffff; */
    /* padding: 4px; */
    /* margin-right: 2px; */
}
.ps-message-suggestions{
    font-size: 12px;
    padding: 2px;
    background-color: #55a2a2;
    color: #ffffff;
    border-radius: 2px;
    line-height: 2;
    margin: 2px;
    word-break: keep-all;
    word-wrap: keep;
    display:inline-block;
}
.unavaliablility-delete-btn{
    font-size: 16px;
    cursor: pointer;
    /* margin-left: 2px; */
    padding: 2px;
    color:#942222;
}
.template-label{
    color: #4D7FAE;
    font-size: 13px;
    font-weight: 400;
}
.mr-30 {
    margin-right: 30px;
}
</style>
